import { useLayoutEffect, useRef } from "react";
import Card from "./card";

const CardList = ({ cards, emptyMessage }) => {
  const section = useRef();
  useLayoutEffect(() => {
    const header = document.getElementById("calendar-header");
    if (header) {
      const headerRect = header.getBoundingClientRect();
      section.current.style.paddingTop = `${headerRect.height + 24}px`;
    }
  }, []);
  const hasCards = !!cards.length;
  return (
    <section id="card-list" ref={section}>
      {hasCards
        ? cards.map((obj) => <Card obj={obj} key={obj._flatId || obj.id} />)
        : !!emptyMessage && <p className="no-results">{emptyMessage}</p>}
    </section>
  );
};

export default CardList;
